import { LoadingBox } from '@components/LoadingBox';
import { IData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import { useMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { AtividadeModal } from '@mod/Atividade/AtividadeModal';
import { ContratoClienteCancelarModal } from '@mod/ContratoCliente/ContratoClienteCancelarModal';
import { ContratoClienteEditarModal } from '@mod/ContratoCliente/ContratoClienteEditarModal';
import { IComboOrigemCancelamento, IContratoCliente } from '@model/ContratoCliente';
import { IComboContratoClienteStatus } from '@model/ContratoClienteStatus';
import { IContratoClienteFilter } from '@services/ClienteService';
import React from 'react';
import { ContratoMenu } from '../../../ContratoCliente/ContratoMenu';
import { ContratoFilter } from './ContratoFilter';
import { ContratoTable } from './ContratoTable';

export type ClienteDetalhesContratosProps = {
    data: IData<IContratoCliente, IContratoClienteFilter>
    contratoClienteStatusCombo: IComboContratoClienteStatus
    origemCancelamentoCombo: IComboOrigemCancelamento
    isLoading: boolean
}

export function ClienteDetalhesContratos ({ data, isLoading, origemCancelamentoCombo, contratoClienteStatusCombo }: ClienteDetalhesContratosProps) {
    const commandLoading = useLoading();

    const cancelarModal = useModalWindow();
    const reativarModal = useModalWindow();
    const editarModal = useModalWindow();
    const atividadeModal = useModalWindow();
    const menu = useMenu();

    return (
        <LoadingBox isLoading={commandLoading.isLoading}>
            <ContratoFilter
                filter={data.filter}
                contratoClienteStatusCombo={contratoClienteStatusCombo}
                isLoading={isLoading}
            />
            
            <ContratoTable
                data={data}
                menu={menu}
                isLoading={isLoading}
            />

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <ContratoMenu
                            menu={menu}
                            contratoCliente={data.focusedRow}
                            cancelarModal={cancelarModal}
                            reativarModal={reativarModal}
                            editarModal={editarModal}
                            commandLoading={commandLoading}
                            atividadeModal={atividadeModal}
                        />

                        <ContratoClienteCancelarModal 
                            modal={cancelarModal}
                            contratoCliente={data.focusedRow}
                            origemCancelamentoCombo={origemCancelamentoCombo}
                            onContratoCancelado={data.handleUpdateFocusedRow}
                        />

                        <ContratoClienteEditarModal
                            contratoCliente={data.focusedRow}
                            modal={editarModal}
                            onContratoClienteEditado={data.handleUpdateFocusedRow}
                        />

                        <AtividadeModal 
                            modal={atividadeModal}
                            entidade='contratocliente'
                            chaves={{
                                contratoClienteId: data.focusedRow.contratoClienteId
                            }}
                        />
                    </React.Fragment>
                )
            }
        </LoadingBox>
    )
}